_ = require 'lodash'
ConfirmationModal = require '../../../a2i/js/components/ConfirmationModal'
extend = require 'extend'
historyActions = require '../actions/history'
LoadingSpinner = require '../../../shared/js/components/LoadingSpinner'
mapValues = require 'lodash/mapValues'
moment = require 'moment'
ObservationInfo = require '../components/ObservationInfo'
ObserveStudents = require '../containers/ObserveStudents'
ObserveTeacher = require '../containers/ObserveTeacher'
React = require 'react'
slow = require '../lib/slow'
SummaryQuestions = require '../containers/SummaryQuestions'
{ Component, PropTypes } = React
{ connect } = require 'react-redux'
{ doFlash } = require '../actions/flash'
{ rehydrateObservation, scoreObservation, uploadObservation } = require '../actions/observations'
{ show } = require '../api/observations'
{
	OBSERVATION_PART_TYPE_IDS: {
		STUDENT
		TEACHER
	}
} = require '../lib/commonIds'

class ObservationContainer extends Component
	@propTypes: {
		isUploadingObservation: PropTypes.bool
		mostRecentObservationId: PropTypes.number
		observation: PropTypes.object
		uploadObservation: PropTypes.func.isRequired
	}

	@contextTypes:
		router: PropTypes.object

	state:
		isPerformingStudentObservation: false
		isPerformingTeacherObservation: false
		isAnsweringSummaryQuestions: false

	componentWillMount: ->
		if (!@props.observation)
			@context.router.push('/observations/new')

	componentWillUnmount: ->
		@props.rehydrateObservation()

	getMostRecentCycle: ->
		return _.last(@props.observation.observation_cycles)

	calculateCycleNumber: ->
		if @props.observation.observation_cycles
			mostRecentCycle = @getMostRecentCycle()

			if mostRecentCycle?.observation_part_type_id == TEACHER && mostRecentCycle?.done
				return mostRecentCycle?.cycle_number + 1
			else
				return mostRecentCycle?.cycle_number
		else
			1

	calculateTimer: ->
		mostRecentCycle = @getMostRecentCycle()

		if mostRecentCycle
			if mostRecentCycle?.done
				localStorage.setItem('currentCycleElapsedSeconds', 0)
				return 0
			else
				timer = 0

				@props.observation.observation_cycles.map (cycle) =>
					matchesCycleNumber = cycle.cycle_number == mostRecentCycle?.cycleNumber
					matchesPartType = cycle.observation_part_type_id == mostRecentCycle?.observation_part_type_id

					if matchesCycleNumber && matchesPartType
						startSeconds = moment(cycle.created_at).format('X')
						endSeconds = moment(cycle.ended_at).format('X')
						timer += endSeconds - startSeconds

				storedTime = localStorage.getItem('currentCycleElapsedSeconds')

				if storedTime
					return timer + parseInt(storedTime)
				else
					return timer
		else
			localStorage.setItem('currentCycleElapsedSeconds', 0)
			return 0


	render: =>
		if !@props.observation
			React.createElement("div", null)
		else
			{ acceptChange, cancelChange, isRequestingHistoryChange } = @props
			{
				fetchError,
				isFetching,
				isAnsweringSummaryQuestions,
				isPerformingStudentObservation,
				isPerformingTeacherObservation
			} = @state

			toggleStudentObservation = =>
				@setState isPerformingStudentObservation: !isPerformingStudentObservation

			toggleTeacherObservation = =>
				@setState isPerformingTeacherObservation: !isPerformingTeacherObservation

			toggleAnswerSummaryQuestions = =>
				@setState isAnsweringSummaryQuestions: !isAnsweringSummaryQuestions

			navigationWarningModal = React.createElement(ConfirmationModal, { \
				"body": (
					React.createElement("div", null,
						React.createElement("strong", null, "Warning!"), " Navigate away from this observation while the timer is running? (", React.createElement("em", null, "unrecoverable"), """)
""", React.createElement("p", null, React.createElement("strong", null, "Recommended:"), " Press pause first, or click the done button!")
					)
				),  \
				"confirmationButtonStyle": "warning",  \
				"confirmationButtonText": "Yes, change screen",  \
				"onCancel": ( cancelChange ),  \
				"onConfirm": ( acceptChange ),  \
				"shouldShow": ( isRequestingHistoryChange ),  \
				"title": "Really change screen?"
			})

			if isPerformingStudentObservation
				React.createElement(ObserveStudents, { \
					"currentCycleNumber": ( @calculateCycleNumber() ),  \
					"gradeLevelId": ( @props.observation.classroom.grade_level_id ),  \
					"navigationWarningModal": ( navigationWarningModal ),  \
					"numberOfCycles": ( @props.observation.number_of_cycles ),  \
					"students": ( @props.observation.students ),  \
					"startTimerAt": ( moment.duration(@calculateTimer(), 'seconds') ),  \
					"studentMinutes": ( moment.duration(@props.observation.student_minutes, 'minutes') ),  \
					"toggleStudentObservation": ( toggleStudentObservation )
				})
			else if isPerformingTeacherObservation
				React.createElement(ObserveTeacher, { \
					"currentCycleNumber": ( @calculateCycleNumber() ),  \
					"gradeLevelId": ( @props.observation.classroom.grade_level_id ),  \
					"navigationWarningModal": ( navigationWarningModal ),  \
					"numberOfCycles": ( @props.observation.number_of_cycles ),  \
					"startTimerAt": ( moment.duration(@calculateTimer(), 'seconds') ),  \
					"teacher": ( @props.observation.teacher ),  \
					"teacherAttrs": ( _.last(@props.observation.teacher_observations) ),  \
					"teacherMinutes": ( moment.duration(@props.observation.teacher_minutes, 'minutes') ),  \
					"toggleTeacherObservation": ( toggleTeacherObservation )
				})
			else if isAnsweringSummaryQuestions
				React.createElement(SummaryQuestions, {"toggleAnswerSummaryQuestions": ( toggleAnswerSummaryQuestions )})
			else
				numberOfCycles = @props.observation.number_of_cycles
				mostRecentCycle = @getMostRecentCycle()

				isTimeForStudentObservation = (
					!mostRecentCycle ||
					(mostRecentCycle?.observation_part_type_id == STUDENT && !mostRecentCycle?.done) ||
					(
						mostRecentCycle?.observation_part_type_id == TEACHER &&
						mostRecentCycle?.done &&
						mostRecentCycle?.cycle_number < numberOfCycles
					)
				)

				isTimeForTeacherObservation = (
					(mostRecentCycle?.observation_part_type_id == STUDENT && mostRecentCycle?.done) ||
					(mostRecentCycle?.observation_part_type_id == TEACHER && !mostRecentCycle?.done)
				)

				isTimeForSummaryQuestions = (
					mostRecentCycle?.cycle_number == numberOfCycles &&
					mostRecentCycle?.observation_part_type_id == TEACHER &&
					mostRecentCycle?.done
				)

				React.createElement(ObservationInfo, { \
					"classroomDescription": ( @props.observation.classroom.description ),  \
					"currentCycleDone": ( mostRecentCycle?.done || false ),  \
					"currentCyclePartTypeId": ( mostRecentCycle?.observation_part_type_id || STUDENT ),  \
					"hasAnsweredSummaryQuestions": ( @props.observation.observation_question_responses?.length > 0 ),  \
					"isUploadingObservation": ( @props.isUploadingObservation ),  \
					"mostRecentObservationId": ( @props.mostRecentObservationId ),  \
					"observation": ( @props.observation ),  \
					"currentCycleNumber": ( @calculateCycleNumber() ),  \
					"isTimeForStudentObservation": ( isTimeForStudentObservation ),  \
					"isTimeForTeacherObservation": ( isTimeForTeacherObservation ),  \
					"isTimeForSummaryQuestions": ( isTimeForSummaryQuestions ),  \
					"toggleStudentObservation": ( toggleStudentObservation ),  \
					"toggleTeacherObservation": ( toggleTeacherObservation ),  \
					"toggleAnswerSummaryQuestions": ( toggleAnswerSummaryQuestions ),  \
					"uploadObservation": ( @props.uploadObservation )
				})

mapStateToProps = (state, ownProps) ->
	isRequestingHistoryChange: state.history.isRequestingHistoryChange
	isUploadingObservation: state.observations.isUploading
	mostRecentObservationId: state.observations.mostRecentObservationId
	observation: state.observations.current

mapDispatchToProps = {
	acceptChange: historyActions.acceptChange
	cancelChange: historyActions.cancelChange
	doFlash
	rehydrateObservation
	show
	uploadObservation
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObservationContainer)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/Observation.cjsx